<template>
    <div style="background-color: #d42b3d" class="font-normal p-2 flex w-full items-center flex">
        <div class="w-full">

            <select 
                v-for="(bmk, index) in data"
                v-model="selected[bmk.label]"
                :key="index"
                class="w-full pl-1 mb-1 mt-2 text-base bg-white rounded h-8 flex-1 items-center"
            >
                <option value="" disabled selected>{{ bmk.default }}</option>
                <option 
                    v-for="(options, index) in bmk.options"
                    :key="index"
                    :value="options.value"
                >
                    {{ options.title }}
                </option>
            </select>

            <button 
                style="background-color: #f69322" 
                class="w-full mt-2 p-2 rounded text-white text-base uppercase"
                @click="search"
            >
                Search for jobs
            </button>
        </div>
    </div>
</template>

<script>

import mockData from '../api/bmk/data.json';

export default {
    name: 'brighterMonday',
    data() {
        return {
            data: {
                type: Array,
                default: () => [],
            },
            selected: {
                jobFunction: "",
                industry: "",
                location: "",
            }
        }
    },
    created() {
        this.data = mockData.data;
    },
    methods: {
        search() {
            const queryParams = {};

            if (this.selected.jobFunction) {
                queryParams.jobFunction = this.selected.jobFunction
            }
            if (this.selected.location) {
                queryParams.location = this.selected.location
            }

            var queryString = Object.keys(queryParams).map(key => encodeURIComponent(queryParams[key])).join('/');

            if (this.selected.industry) {
                if (queryString) {
                    queryString = queryString.concat(`?industry[]=${this.selected.industry}`);
                } else {
                    queryString = this.selected.industry
                }
            }
            
            window.open(`https://www.brightermonday.co.ke/jobs/${queryString}`, '_blank')
        }
    },
}
</script>

<style scoped>
    @import '../assets/styles/cheki/app.css';
</style>